<div class="block--content block">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>
        <div class="ticket">
            <div class="intro-text">
                <p class="title">
                    {{ 'BANKCARD_DETAIL_TITLE' | translate }}
                </p>
                <p class="remove-for-print-layout">
                    {{ 'BANKCARD_STATUS_NOTIFICATION_BODY' | translate }}
                </p>
            </div>
        </div>
        <rwidget-bankcard-tickets></rwidget-bankcard-tickets>
    </div>
</div>
